import { call, put, takeLatest } from 'redux-saga/effects';
import fetchData from 'app/utils/fetchData';
import { JOB } from './queries';
import { fetchJobData, jobError, storeJobData } from './slice';
import { catchError } from '@utils/sentry';
export function* fetchJobWorker(action) {
    try {
        const workflowId = action.payload.workflowId;
        const workflowIdNum = Number(workflowId);
        if (isNaN(workflowIdNum) || workflowIdNum <= 0) {
            yield put(jobError('Invalid workflow_id'));
            return;
        }
        const queryVariables = { workflow_id: workflowIdNum };
        const response = yield call(fetchData, {
            queryString: JOB,
            queryKey: 'wft_job',
            queryVariables,
        });
        const result = Array.isArray(response) ? response : [];
        let jobDescriptionBlocks = [];
        let validBlocks = false;
        if (result && result.length > 0 && result[0].description) {
            if (Array.isArray(result[0].description) && result[0].description.length > 0) {
                jobDescriptionBlocks = result[0].description;
                validBlocks =
                    Array.isArray(jobDescriptionBlocks) &&
                        jobDescriptionBlocks.every((block) => block &&
                            typeof block.id === 'string' &&
                            typeof block.type === 'string' &&
                            Array.isArray(block.content) &&
                            Array.isArray(block.children));
                const jobWithBlocks = {
                    ...result[0],
                    jobDescriptionBlocks,
                    validBlocks,
                };
                const newResult = [jobWithBlocks, ...result.slice(1)];
                yield put(storeJobData(newResult));
            }
        }
    }
    catch (error) {
        yield call(catchError, {
            title: 'Fetching job failed.',
            error: error,
        });
        yield put({ type: jobError.type, payload: error });
    }
}
export function* fetchJobWatcher() {
    yield takeLatest(fetchJobData.type, fetchJobWorker);
}
